import React, { useContext } from 'react';

import { IconXmarkRound } from '@/components/apps/ui/icon';

import theme from '@/styles/theme';

import ButtonIcon from '../../buttons/ButtonIcon';
import { ModalContext } from './Modal';

type Props = {
  title: React.ReactNode;
  onClose: () => void;
};

export const MODAL_HEADER_HEIGHT = 64;

export default function ModalHeader({ title, onClose }: Props) {
  const { color } = useContext(ModalContext);

  return (
    <div className="flex h-[64px] items-center justify-between py-3 pl-5 pr-3">
      <h1
        className={`text-xl font-bold leading-[140%] tracking-[-0.4px] ${
          color === 'black'
            ? 'text-apps-coreGrayWhite'
            : 'text-apps-coreGrayBlack'
        }`}
      >
        {title}
      </h1>
      <ButtonIcon type="button" onClick={onClose} aria-label="닫기">
        {color === 'white' ? (
          <IconXmarkRound size={24} aria-hidden="true" />
        ) : (
          <IconXmarkRound
            size={24}
            color={theme`colors.apps.coreGrayWhite`}
            aria-hidden="true"
          />
        )}
      </ButtonIcon>
    </div>
  );
}
